import React from 'react'
import { Link } from 'gatsby'
import APIRecurSwagger from './APIRecurSwagger'

export default function Definitions({ definitions }) {
  if (!definitions || definitions.length === 0) {
    return null
  }
  // console.log(JSON.stringify(definitions));
  return (
    <div className="dax-definitions" id="definitions">
      <header className="dax-topic-definition">
        <h2 className="dx-anchor">
          <Link to="#definitions" aria-hidden="true" />
          Common object definitions
        </h2>
      </header>

      {definitions.map((definition, index) => {
        if (definition && definition.href) {
          return (
            <div
              className="dax-reference-set dx-flex"
              id={`definition-${definition.href}`}
              data-cy={`${definition.href}`}
              key={index}
            >
              <div className="dax-reference">
                {/* API RECUR SWAGGER HERE */}
                <APIRecurSwagger definition={definition} />
              </div>
            </div>
          )
        }
      })}
    </div>
  )
}
